import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { campaignsApi, staticAdv, widgetsApi } from '@/api/index';
import type { AdsBody, CampaignBody, StaticCampaignBody } from '@/api/routes/campaigns/types';

export const fetchCampaigns = createAsyncThunk(
  'campaigns',
  async (params: CampaignBody, thunkAPI) => {
    try {
      const response = await campaignsApi.getAll(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchCampaignsAdv = createAsyncThunk(
  'campaigns',
  async (params: StaticCampaignBody, thunkAPI) => {
    try {
      const response = await staticAdv.getAll(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchCampaignsWidgets = createAsyncThunk(
  'campaigns',
  async (params: StaticCampaignBody, thunkAPI) => {
    try {
      const response = await widgetsApi.getAll(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchAds = createAsyncThunk(
  'ads',
  async (params: AdsBody, thunkAPI) => {
    try {
      const response = await campaignsApi.getAds(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchAdsWidgets = createAsyncThunk(
  'ads',
  async (params: AdsBody, thunkAPI) => {
    try {
      const response = await widgetsApi.getAll(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchCampaignsStat = createAsyncThunk(
  'campaignsStat',
  async (params, thunkAPI) => {
    try {
      const response = await campaignsApi.getStat();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
